export async function getLatestSynchronization(thisSynchronizationInfo) {
    try {
        const latestRecord = await thisSynchronizationInfo
            .orderBy('synchronizationDate')
            .last();
        return latestRecord;
    } catch (error) {
        return null
    }
}